import React from "react";


export default function YouTubeEmbed({ url }) {
// Extract video id from common youtube url forms
const match = url.match(/(?:v=|\/)([0-9A-Za-z_-]{11})/);
const id = match ? match[1] : null;
if (!id) return <a href={url} target="_blank" rel="noreferrer">{url}</a>;
const embed = `https://www.youtube.com/embed/${id}`;


return (
<div style={{ position: "relative", paddingTop: "56.25%" }}>
<iframe
src={embed}
title="YouTube video"
frameBorder="0"
allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
allowFullScreen
style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", borderRadius: 8 }}
/>
</div>
);
}